import { useEffect } from "react";
import { filter, isEmpty, map } from "lodash";
import * as aiccAPI from "services/aiccCustomer";
import { useAICCStore } from "./useAICCStore";

export default function useAiccLanguages() {
  const languages = useAICCStore((state) => state.languages);
  const setLanguages = useAICCStore((state) => state.setLanguages);

  useEffect(() => {
    if (!isEmpty(useAICCStore.getState().languages)) {
      return;
    }
    aiccAPI
      .fetchAiccLanguages()
      .then((response) => setLanguages(map(filter(response, "has_ever_published"), ({ id, name }) => ({ id, name }))));
  }, [setLanguages]);

  return languages;
}
